// @ts-nocheck



import React, { Component } from 'react';





import InnerTable from './InnerTable';
import Filter from './FilterVehicleList';
















export default class extends Component {
  state = {
    loading: false,
    data: [],
    selectedRowKeys: [],
    filter: { ...null }
  };

  async componentDidMount() {}

  onSelect = (
  record,
  selected,
  selectedRows) =>
  {
    const { data } = this.props;
    let { selectedRowKeys } = this.state;
    const index = data.findIndex((element) => {
      return element.id === record.id;
    });
    if (selected) {
      selectedRowKeys = [...selectedRowKeys, index];
    } else {
      selectedRowKeys = selectedRowKeys.filter(
        (selectedRowKey) => selectedRowKey !== index
      );
    }
    this.setState({ selectedRowKeys }, () =>
    this.props.onChange(this.props.contractVehiclePlanType, selectedRows)
    );
  };

  onSelectAll = (selected, selectedRows) => {
    const { data } = this.props;
    const length = data ? data.length : 0;
    this.setState(
      {
        selectedRowKeys: selected ?
        Array(length).
        fill().
        map((item, index) => index) :
        []
      },
      () =>
      this.props.onChange(this.props.contractVehiclePlanType, selectedRows)
    );
  };

  applyFilter = (filter) => {
    this.setState({ filter, selectedRowKeys: [] }, () =>
    this.props.applyFilter(this.props.contractVehiclePlanType, filter)
    );
  };

  cleanFilter = () => {
    this.setState({ filter: { ...null }, selectedRowKeys: [] }, () =>
    this.props.cleanFilter(this.props.contractVehiclePlanType)
    );
  };

  render() {
    const { data, loading } = this.props;
    const { selectedRowKeys, filter } = this.state;
    return (
      <>
        <Filter
          applyFilter={this.applyFilter}
          cleanFilter={this.cleanFilter}
          filter={filter} />

        <InnerTable
          data={data}
          selectedRowKeys={selectedRowKeys}
          onSelect={this.onSelect}
          onSelectAll={this.onSelectAll}
          loading={loading} />

      </>);

  }
}
